import * as React from 'react';
import { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, DateField, DateInput } from 'react-admin';
import {
  useListContext,
  useRedirect,
  useNotify,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,

  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  BulkDeleteWithConfirmButton,
  Show,
  SimpleShowLayout,

  ReferenceField,
  TextField,
  ImageField,
  BooleanField,
  FunctionField,

  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  BooleanInput,
  NullableBooleanInput,

  Button,
  EditButton,
  ShowButton,
  SaveButton,
  FormDataConsumer,
} from 'react-admin';
import { Button as CButton, Box, Dialog, DialogTitle, DialogContent, DialogActions, TextField as MuiTextField } from '@material-ui/core';
import { PreviewImage, UpLoadFile } from './custom/UpLoadFile';
import { ArrowBack, Search } from '@material-ui/icons';
import { SelectByEnum, TextByEnum } from './custom/Enum';
import { apiUrl } from '../global';
import { httpClient } from '../dataProvider';
import qs from 'qs';
//import ResetOrderNum from './S_zuowu_ResetOrderNum';

{/* 
  import { S_zuowuList, S_zuowuCreate, S_zuowuEdit, S_zuowuShow } from './components/S_zuowu';

  <Resource name="CMSS_zuowu" list={S_zuowuList} create={S_zuowuCreate} edit={S_zuowuEdit} show={S_zuowuShow} />
  <Resource name="CMSS_zuowu" list={ListGuesser} create={EditGuesser} edit={EditGuesser} edit={ShowGuesser} /> 
*/}

const useStyles = makeStyles({
  imageField: {
    '& img': { width: 60 }
  },
});

const useTxtData = {
  page: {
    tableName: 'S_zuowu',
  },
  table: {
    id: 'id',
    jinying_id: '主体',
    dikuai_id: '地块',
    zuowu: '作物',
    status: '状态',
    jiangkangdu: '健康度',
    touru_jine: '投入金额(万元)',
    chanchu_jine: '产出金额(万元)',
    chanliang: '预估产量(KG)',
    StartTime: '起始时间',
    EndTime: '结束时间',
  }
};

//分页列表页面
export const S_zuowuList = (props) => {
  //筛选器模块
  // const Filters = (props) => {
  //   return (
  //     <Filter {...props}>
  //       <TextInput label="ID" source="id" alwaysOn resettable />
  //       {/* <TextInput label="XX" source="name" alwaysOn resettable /> */}
  //     </Filter>
  //   );
  // };
  const Filters = (props) => {
    const { displayedFilters, filterValues, setFilters, hideFilter, } = useListContext();
    if (props.context === "button") return null;
    const onSubmit = values => { if (Object.keys(values).length > 0) { setFilters(values); } else { setFilters({}, []); } };
    const resetFilter = () => { setFilters({}, []); };
    return (
      <div>
        <Form onSubmit={onSubmit} initialValues={filterValues}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Box display='flex' alignItems='center'>
                <Box component="span" mr={2}>
                  <TextInput label="ID" source="id" alwaysOn resettable />
                </Box>
                <Box component="span" mr={2} mb={2.5}>
                  <CButton variant="contained" color="primary" type="submit" startIcon={<Search />}>搜索</CButton>
                </Box>
                <Box component="span" mr={2} mb={2.5}>
                  <CButton variant="outlined" onClick={resetFilter}>重置</CButton>
                </Box>
              </Box>
            </form>
          )}
        </Form>
      </div>
    );
  };

  //批量操作模块
  const AssetBulkActionButtons = (props) => {
    return (
      <Fragment>
        {/* <ResetOrderNum label="重置排序" {...props} /> */}
        <BulkDeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" />
      </Fragment>
    );
  };
  //行右侧功能按钮
  const RowAction = (props) => {
    const notify = useNotify();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [prompt, setPrompt] = useState('');
    const handleCreateBG = async () => {
      setDialogOpen(false);
      notify('报告给予DeepSeekAI大模型正在生成中,请稍候在"分析报告"页面查看...');
      try {
        const { json } = await httpClient(`${apiUrl}/Admin/CMSS_zuowu/CreateBG`, {
          method: 'POST',
          contentType: 'application/x-www-form-urlencoded',
          body: qs.stringify({ id: props.record.id, prompt })
        });
        if (json.Code === 1) {
          notify(json.Message || '报告生成成功', { type: 'success' });
        } else {
          notify(json.Message || '生成失败', { type: 'warning' });
        }
        setPrompt('');
      } catch (error) {
        notify('系统错误，请稍后重试', { type: 'warning' });
      }
    };
    return (
      <div style={{ textAlign: 'right' }}>
        <EditButton {...props} /><br />
        <ShowButton {...props} /><br />
        <CButton
          variant="contained"
          color="primary"
          size="small"
          onClick={() => setDialogOpen(true)}
        >
          手动生成预测报告
        </CButton><br />
        <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>自定义提示词</DialogTitle>
          <DialogContent>
            <MuiTextField
              autoFocus
              multiline
              rows={4}
              fullWidth
              placeholder="输入你对报告生成的补充要求或关注重点..."
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <CButton onClick={() => setDialogOpen(false)}>取消</CButton>
            <CButton onClick={handleCreateBG} color="primary" variant="contained">确认生成</CButton>
          </DialogActions>
        </Dialog>
        {/* <DeleteWithConfirmButton {...props} confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" /> */}
      </div>
    );
  }

  const classes = useStyles();
  return (
    <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} filters={<Filters />} bulkActionButtons={<AssetBulkActionButtons />} >
      <Datagrid>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        {/* <TextField label={useTxtData.table.jinying_id} source="jinying_id" /> */}
        <ReferenceField label={useTxtData.table.jinying_id} source="jinying_id" reference="Admin/CMSS_jinyingzhuti" link={false}>
          <TextField source="ComName" />
        </ReferenceField>
        {/* <TextField label={useTxtData.table.dikuai_id} source="dikuai_id" /> */}
        <ReferenceField label={useTxtData.table.dikuai_id} source="dikuai_id" reference="Admin/CMSS_dikuai" link={false}>
          <FunctionField render={() =>
            <><TextField source="Mianji" /><span>亩</span></>
          } />
        </ReferenceField>
        <TextField label={useTxtData.table.zuowu} source="zuowu" />
        {/* <TextField label={useTxtData.table.status} source="status" /> */}
        <TextByEnum label={useTxtData.table.status} source="status" EnumName='api.Models.S_ZuowuType' OnlyText={true} />
        <TextField label={useTxtData.table.jiangkangdu} source="jiangkangdu" />
        <TextField label={useTxtData.table.touru_jine} source="touru_jine" />
        <TextField label={useTxtData.table.chanchu_jine} source="chanchu_jine" />
        <TextField label={useTxtData.table.chanliang} source="chanliang" />
        <DateField label={useTxtData.table.StartTime} source="StartTime" />
        <DateField label={useTxtData.table.EndTime} source="EndTime" />
        <RowAction />
      </Datagrid>
    </List>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//SHOW页面
export const S_zuowuShow = (props) => {
  const ShowActions = (props) => {
    const { basePath, data } = props; const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
        <EditButton basePath={basePath} record={data} />
      </TopToolbar>
    );
  };

  const classes = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={<ShowActions />}>
      <SimpleShowLayout>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.jinying_id} source="jinying_id" />
        <TextField label={useTxtData.table.dikuai_id} source="dikuai_id" />
        <TextField label={useTxtData.table.zuowu} source="zuowu" />
        {/* <TextField label={useTxtData.table.status} source="status" /> */}
        <TextByEnum label={useTxtData.table.status} source="status" EnumName='api.Models.S_ZuowuType' OnlyText={true} />
        <TextField label={useTxtData.table.jiangkangdu} source="jiangkangdu" />
        <TextField label={useTxtData.table.touru_jine} source="touru_jine" />
        <TextField label={useTxtData.table.chanchu_jine} source="chanchu_jine" />
        <TextField label={useTxtData.table.chanliang} source="chanliang" />
        <TextField label={useTxtData.table.StartTime} source="StartTime" />
        <TextField label={useTxtData.table.EndTime} source="EndTime" />
      </SimpleShowLayout>
    </Show>
  );
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//编辑页面
export const S_zuowuEdit = (props) => {
  const PostEditActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = (props) => {
    return (
      <Toolbar {...props}>
        <SaveButton />
      </Toolbar>
    );
  };
  return (
    <Edit title={'编辑' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostEditActions />}>
      <MyForm Edit={true} toolbar={<PostEditToolbar />} />
    </Edit>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//创建页面
export const S_zuowuCreate = (props) => {
  const PostCreateActions = (props) => {
    const { basePath } = props; const redirect = useRedirect();
    return (
      <TopToolbar {...props}>
        <Button label="返回列表" onClick={() => redirect(basePath)} variant="text" >
          <ArrowBack />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = (props) => {
    const { basePath } = props;
    return (
      <Toolbar {...props}>
        <SaveButton label="保存&列表" redirect={basePath} submitOnEnter={true} />
        <SaveButton label="保存&继续" redirect={false} submitOnEnter={false} variant="text" />
      </Toolbar>
    );
  };

  return (
    <Create title={'新增' + useTxtData.page.tableName} undoable={false} {...props} actions={<PostCreateActions />}>
      <MyForm Create={true} toolbar={<PostCreateToolbar />} />
    </Create>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
//Create和Edit公用表单
const MyForm = (props) => {
  let { Edit, Create } = props;
  return (
    <SimpleForm {...props} >
      {/* <TextInput source="Name" /> */}
      {/* <NumberInput source="OrderNum" /> */}
      {/* <TextInput label={useTxtData.table.id} source="id" validate={[required()]} /> */}

      <ReferenceInput label={useTxtData.table.jinying_id} source="jinying_id" reference="Admin/CMSS_jinyingzhuti" link={false}>
        <SelectInput optionText="ComName" />
      </ReferenceInput>
      {/* <TextInput label={useTxtData.table.jinying_id} source="jinying_id" validate={[required()]} /> */}

      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <ReferenceInput label={useTxtData.table.dikuai_id} source="dikuai_id" reference="Admin/CMSS_dikuai" link={false} filter={{ jinying_id: formData.jinying_id }} {...rest}>
            <SelectInput optionText={'Mianji'} />
          </ReferenceInput>
        )}
      </FormDataConsumer>
      {/* <TextInput label={useTxtData.table.dikuai_id} source="dikuai_id" validate={[required()]} /> */}

      <TextInput label={useTxtData.table.zuowu} source="zuowu" validate={[required()]} />
      {/* <TextInput label={useTxtData.table.status} source="status" validate={[required()]} /> */}
      <SelectByEnum label={useTxtData.table.status} source="status" EnumName='api.Models.S_ZuowuType' OnlyText={true} resettable />
      <TextInput label={useTxtData.table.jiangkangdu} source="jiangkangdu" validate={[]} />
      <TextInput label={useTxtData.table.touru_jine} source="touru_jine" validate={[]} />
      <TextInput label={useTxtData.table.chanchu_jine} source="chanchu_jine" validate={[]} />
      <TextInput label={useTxtData.table.chanliang} source="chanliang" validate={[]} />
      <DateInput label={useTxtData.table.StartTime} source="StartTime" validate={[required()]} />
      <DateInput label={useTxtData.table.EndTime} source="EndTime" validate={[]} />
    </SimpleForm>
  );
}